import { useEffect, useState} from "react"
import Input from "../../blocks/Input"
import { useForm } from "../../hooks/useForm"
import utils from "../../scripts/utils"
import { useSnackbar } from "notistack"
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import './role-form.css'
import { ajax } from "../../scripts/helper"
import { useNavigate } from "react-router-dom"


const RoleForm = ({type, state}) => {
    const {enqueueSnackbar} = useSnackbar()
    const navigate = useNavigate()

    const [readOnly, setReadOnly] = useState(false)


    const [inputFields, handleChange, setInputFields] = useForm({
        name:{
            name: 'name',
            value: '',
            type: 'text',
            placeholder: '...'
        },
        description:{
            name: 'description',
            value: '',
            type: 'textarea',
            placeholder: 'Write here'
        },
        privileges: {
            name: 'privilages',
            value: '',
            type: 'select',
            selected: null,
            items:[]
        },
        status: {
            name: 'status',
            value: '',
            type: 'select',
            selected: null,
            items:[
                {label:'ACTIVE', data: {label: 'ACTIVE'}},
                {label: 'INACTIVE', data: {label: 'INACTIVE'}},
                {label: 'PENDING', data: {label: 'PENDING'}},
                {label: 'DELETED', data: {label: 'DELETED'}},
            ]
        }
    })

    const [privilegesOption, setPrivilegesOption] = useState([])
    const [privilegeValue, setPrivilegeValue] = useState([])

    const getPrivileges = async () => {
        const res = await ajax({
            method: 'GET',
            url: utils.urls.privilegeList,
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if(!res) return

        setPrivilegesOption(res.data)
    }

    const buttonAction = () => {
        if(type === 'create') createRole()
        if(type === 'edit') editRole()
    }

    const fillData = (data) => {
        setInputFields({
            ...inputFields,
            name: {
                ...inputFields.name,
                value: data.name
            },
            description: {
                ...inputFields.description,
                value: data.description
            },
            status: {
                ...inputFields.status,
                value: data.status
            }
        })

        setPrivilegeValue(data.privileges)
    }

    const createRole = async () => {
        let privileges = []
        for(const p of privilegeValue){
            privileges.push(p.id)
        }
        let body = {
            "name": inputFields.name.value.toUpperCase(),
            "description": inputFields.description.value,
            "privileges": privileges,
            "status": "ACTIVE"
        }

        console.log(privileges)
        const res = await ajax({
            method: 'POST',
            hasToken: true,
            url: utils.urls.createRole,
            snackbar: enqueueSnackbar,
            data: body
        })

        if(!res) return

        navigate('/agent/roles')
    }

    const editRole = async () => {
        let privileges = []
        for(const p of privilegeValue){
            privileges.push(p.id)
        }
        let body = {
            "name": inputFields.name.value.toUpperCase(),
            "description": inputFields.description.value,
            "privileges": privileges,
            "status": inputFields.status.value.label
        }

        console.log(privileges)
        console.log(body, 'thisis body')
        const res = await ajax({
            method: 'PUT',
            hasToken: true,
            url: utils.urls.updateRole(state.id),
            snackbar: enqueueSnackbar,
            data: body
        })

        if(!res) return

        navigate('/agent/roles')
    }

    const getRoleDetail = async() => {
        const res = await ajax({
            method: 'GET',
            hasToken: true,
            url: utils.urls.roleDetail(state.id),
            snackbar: enqueueSnackbar
        })

        if(!res) return 

        fillData(res.data)
    }

    useEffect( () => {

        if(type !== 'detail') getPrivileges()
        if(type === 'detail') setReadOnly(true)
        if(type !== 'create') getRoleDetail()
        
    },[])

    return (
        <>       
            
            <div className="role-form-container__roleHeader">{(type === 'create' ? 'Create Role' : (type === 'edit' ? 'Edit Role' : 'Role Detail'))}</div>
            <div className="tag">
                    <label className="lbl">Role name</label>
                    <div className="box">
                        <Input
                        className="extra"
                        inputField={inputFields.name}
                        onChange={handleChange}
                        readOnly={readOnly}
                        />
                    </div>
                </div>
            <div className="description">
                    <label>Description</label>
                    <div className="text-box">
                        <Input className="extra"
                        onChange={handleChange}
                        placeholder="Write here ..."
                        inputField={inputFields.description}
                        readOnly={readOnly}

                        />
                    </div>
            </div>
            <div className="tag">
                <label className="lbl">Privileges</label>
                <Autocomplete
                    multiple
                    id="tags-outlined"
                    options={privilegesOption}
                    getOptionLabel={(option) => option.name}
                    // defaultValue={[]}
                    value={privilegeValue}
                    filterSelectedOptions
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        />
                    )}
                    onChange={(event , newValue) => {
                        console.log(event , 'lllll', newValue)
                        setPrivilegeValue(newValue)
                    }}
                    readOnly={readOnly}
                    disableCloseOnSelect

                />
            </div>
            {
                type !== 'create' && 
                <div className="tag" style={{marginTop: "20px"}}>
                <label className="lbl">Status</label>
                <Autocomplete
                    id="tags-outlined"
                    options={inputFields.status.items}
                    // getOptionLabel={(option) => (type === 'edit' ? option.name :)}
                    // defaultValue={[]}
                    value={inputFields.status.value}
                    filterSelectedOptions
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        />
                    )}
                    onChange={(event , newValue) => {
                        console.log(event , 'lllll', newValue)
                        setInputFields({
                            ...inputFields,
                            status: {
                                ...inputFields.status,
                                value: newValue
                            }
                        })
                    }}
                    readOnly={readOnly}
                    disableCloseOnSelect

                />
            </div>
            }

            {
                type !== 'detail' &&
                <div className="role-edit-btn">
                    <button className="delete" onClick={() => navigate('/agent/roles')}>Cancel</button>
                    <button className="save" onClick={() => buttonAction()}>{(type === 'create' ?'Create' : 'Save changes')}</button>
                </div>
            }
            {
                type === 'detail' &&
                <div className="role-edit-btn">
                    <button className="back" onClick={() => navigate('/agent/roles')}>Back</button>
                </div>
            }
        </>

    )
}
export default RoleForm